<template>
    <v-container>
        <v-breadcrumbs :items="location" large></v-breadcrumbs>

        <v-dialog v-model="dialog" persistent max-width="400">
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="mx-2" fab color="indigo">
                    <v-icon dark>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    Nueva Nota
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="newNote.title" label="Título"></v-text-field>
                    <v-textarea v-model="newNote.content" label="Contenido"></v-textarea>
                    <v-color-picker class="ma-2" :swatches="swatches" show-swatches v-model="newNote.color" hide-canvas
                        hide-inputs hide-sliders dot-size> </v-color-picker>
                    <v-btn color="green darken-1" text @click="dialog = false">
                        Disagree
                    </v-btn>
                    <v-btn @click="addNote" color="primary" :disabled="!newNote.content">Agregar Nota</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" v-for="(note, index) in notes" :key="index">
                <Note :title="note.title" :content="note.content" :color="note.color" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Note from './Note.vue';

export default {

    components: {
        Note,
    },
    data() {
        return {
            location: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '#',
                },
                {
                    text: 'Inicio',
                    disabled: false,
                    href: '#',
                }
            ],
            dialog: false,
            notes: [],
            newNote: {
                title: '',
                content: '',
                color: '#FFB74D',
            },
            swatches: [
                ['#FFB74D', '#FF9800', '#F57C00'],
                ['#FFD54F', '#FFC107', '#FFA000'],
                ['#81C784', '#4CAF50', '#388E3C'],
                ['#80CBC4', '#009688', '#00796B'],
                ['#64B5F6', '#2196F3', '#1565C0'],
            ]
        };
    },
    methods: {
        addNote() {
            if (this.newNote.title && this.newNote.content && this.newNote.color) {
                this.notes.push({ ...this.newNote });
                this.newNote.title = '';
                this.newNote.content = '';
                this.newNote.color = '';
            }
            this.dialog = false;
        },
    },
};
</script>
